import React, { useEffect, useState } from "react";
import { useTransition, animated } from "react-spring";
import "./index.scss";
import BasicLayout from "../../layouts/BasicLayout";
import Logo from "../../assets/introduction/words.png";

const Introduction = ({ startGame }) => {
  const [logo, setLogo] = useState(false);
  const transitions = useTransition(logo, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: {
      mass: 5,
    },
  });

  useEffect(() => {
    setTimeout(() => {
      setLogo(true);
    }, 2000);
  }, []);

  return (
    <BasicLayout>
      <div className="introduction">
        <div className="cloud" />
        {transitions.map(({ item, key, props }) =>
          item ? (
            <animated.div key={key} style={props}>
              <div className="text-intro">
                <div>
                  <p>叮咚，您收到来自牛郎/织女的一条信息：</p>
                </div>
                <div>
                  <p className="poet">
                    “纤云弄巧，飞星传恨。银汉迢迢暗度。 金风玉露一相逢，便胜却人间无数。
                    柔情似水，佳期如梦，忍顾鹊桥归路。 两情确在久长时，还等你前来相助！”
                  </p>
                </div>
                <div>
                  <p>夏虫长鸣，七夕将近。解开十道灯谜，你就能帮牛郎织女完成他们一年一度的相会。</p>
                </div>
                <div className="button-container">
                  <button onClick={() => startGame()} className="primary-button">
                    开始游戏
                  </button>
                </div>
              </div>
            </animated.div>
          ) : (
            <animated.div key={key} className="logo" style={props}>
              <img className="logo-image" src={Logo} height="361px" width="300px" />
            </animated.div>
          )
        )}
      </div>
    </BasicLayout>
  );
};

export default Introduction;
